import { FC } from 'react';
import { Box } from '@chakra-ui/react';

import CloseButton from 'components/CloseButton';
import * as ContentLayout from 'layouts/ContentLayout';

import CreateNewAccountCard from './components/CreateNewAccountCard';

const CreateNewAccount: FC = () => (
  <ContentLayout.Root>
    <ContentLayout.Body>
      <Box marginBottom="space-40">
        <CloseButton to="/" />
      </Box>

      <CreateNewAccountCard />
    </ContentLayout.Body>
  </ContentLayout.Root>
);

export default CreateNewAccount;
